import { createFileRoute } from '@tanstack/react-router';

import { buildSeoHead, ROUTE_META } from '@src/corelib/seo';
import { DefaultLayout } from '@src/layout';
import { IndustriesSection as IndustriesPage } from '@src/pages/Industries/Industry';

export const Route = createFileRoute('/industries/')({
  head: () => buildSeoHead({ path: '/industries', ...ROUTE_META['/industries'] }),
  component: IndustriesPageWithLayout,
});

function IndustriesPageWithLayout() {
  return (
    <DefaultLayout>
      <IndustriesPage />
    </DefaultLayout>
  );
}
